import _ from 'lodash';

const lodash = {
  // 배열 비교
  isEqual: (arr1, arr2) => {
    if (!arr1 || !arr2) return false;

    if (arr1.length !== arr2.length) return false;
    else if (!arr1.length || !arr2.length) return false;
    return _.isEqual(arr1, arr2);
  },

  // 두 객체 비교
  isObjEqual: (obj1, obj2) => {
    if (!obj1 || !obj2) return false;
    return _.isEqual(obj1, obj2);
  },

  // 인덱스 찾기
  findIndex: (arr, target) => {
    if (!arr.length) return -1;
    return _.findIndex(arr, (item) => _.isEqual(item, target));
  },

  // 배열을 이중배열 정제
  chunk: (arr, size) => {
    return _.chunk(arr, size);
  },

  // 배열에 값이 존재하는지 체크
  some: (arr, target) => {
    return _.some(arr, target);
  },

  debounce: (callback, delay = 500) => {
    return _.debounce((...args) => {
      callback(...args);
    }, delay);
  },
};

export default lodash;
